import React, { useEffect, useState } from "react";
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label,
    EmptyItem,
} from "devextreme-react/form";
import { Button } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarContribuinteDs } from "../../DataSources";
import Memoria from "../../Memoria";
import { LoadIndicator } from "devextreme-react/load-indicator";
import ShowError from "../../AppServices";
import api from "../../api-axios";
import { useHistory } from "react-router-dom";


const ParametrosPixForm = (props) => {

    const template = {
        id: undefined,
        prefeituraId: undefined,
        nomeChave: undefined,
        chavePadrao: false,
        fornecedorPix: 1,
        chavePix: "",
        convenio: "",

        /*Uso interno da tela, não apagar*/
        loadIndicatorVisivel: false,
        textoBotao: "Salvar",
        _uiCarregando: false,
        _uiTextoBotao: "Carregando...",

    };

    template.prefeituraId = UserInfo.getPrefeitura();

    const [state, setState] = useState(template);

    const history = useHistory();



    const simNaoOptions = {
        searchEnabled: false,
        dataSource: [
            { id: true, descricao: "SIM" },
            { id: false, descricao: "NÃO" },
        ],
        valueExpr: "id",
        displayExpr: "descricao"
    };

    const bancosOptions = {
        searchEnabled: false,
        dataSource: [
            { id: 0, descricao: "NENHUM" },
            { id: 1, descricao: "BANCO DO BRASIL" },
        ],
        valueExpr: "id",
        displayExpr: "descricao"
    };

    useEffect(() => {
        if (props.match.params.id !== undefined) {

            setState({ ...state, _uiCarregando: true, _uiTextoBotao: "Carregando..." });

            api.get(`config_pix/${UserInfo.getPrefeitura()}/${props.match.params.id}`)
                .then(response => {
                    setState({ ...state, ...response.data, _uiCarregando: false });
                })
                .catch(error => {
                    ShowError(error.response.data);
                    history.goBack();
                });

        } else {
            setState({ ...template, _uiCarregando: false });
        }
    }, []);

    const ok = async () => {

        setState({ ...state, loadIndicatorVisivel: true, _uiTextoBotao: "Salvando...", });

        const entidade = {
            ...state,
            prefeituraId: UserInfo.getPrefeitura()
        };

        let response;

        try {
            if (!entidade.id || entidade.id === 0) {
                response = await api.post("config_pix", entidade);
            }
            else {
                response = await api.put("config_pix", entidade);
            }

            history.push("/parametros_pix");
        }
        catch (error) {
            console.log(error);
            // ShowError(error.response.data);
            setState({ ...state, loadIndicatorVisivel: false, textoBotao: "Salvar" });
        }


    }

    const cancel = () => {
        notify("Operação cancelada", "warning");
        history.goBack();
    }

    if (state._uiCarregando) {
        return (
            <div className={"content-block dx-card responsive-paddings"}>
                <div
                    style={{
                        display: "flex",
                        marginTop: "25px",
                        justifyContent: "center",
                        alignContent: "center",
                        justifyItems: "center",
                        alignItems: "center",
                    }}
                >
                    <LoadIndicator width={60} height={60} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className={"content-block dx-card responsive-paddings"}>
                <form>
                    <Form formData={state} colCount={2}>

                        <SimpleItem dataField={"id"} colSpan={2} editorOptions={{ readOnly: true }}>
                            <Label text="ID" />
                        </SimpleItem>

                        <SimpleItem dataField={"nomeChave"} colSpan={2}>
                            <Label text="Nome" />
                        </SimpleItem>

                        <SimpleItem
                            dataField={"chavePadrao"}
                            colSpan={2}
                            editorType={"dxSelectBox"}
                            editorOptions={simNaoOptions}
                        >
                            <Label text="Padrão" />
                        </SimpleItem>
                        <SimpleItem
                            dataField={"fornecedorPix"}
                            colSpan={2}
                            editorType={"dxSelectBox"}
                            editorOptions={bancosOptions}
                        >
                            <Label text="Banco" />
                        </SimpleItem>

                        <SimpleItem dataField={"chavePix"} colSpan={2}>
                            <Label text="Chave PIX" />
                        </SimpleItem>

                        <SimpleItem dataField={"convenio"} colSpan={2}>
                            <Label text="Convênio" />
                        </SimpleItem>
                    </Form>

                    <div
                        style={{
                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={120}
                                text="Salvar"
                                type="success"
                                onClick={ok}
                                disabled={state.loadIndicatorVisivel}
                            >
                                <LoadIndicator
                                    className="button-indicator"
                                    id="small-indicator"
                                    height={20}
                                    width={20}
                                    visible={state.loadIndicatorVisivel}
                                    style={{ marginRight: "10px", verticalAlign: "middle" }}
                                />
                                <span className="dx-button-text">
                                    {state.textoBotao}
                                </span>
                            </Button>
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "10px" }}>
                            <Button
                                disabled={state.loadIndicatorVisivel}
                                text="Cancelar"
                                width={120}
                                onClick={cancel}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </React.Fragment>
    );

}

export default ParametrosPixForm;